import { config } from '@/config';
import { UnableToCompleteError } from './apiError';

type HttpMethod = 'get' | 'post';

export class RawApi {

  protected async fetchScoresApi(path: string): Promise<Response>;
  protected async fetchScoresApi<T extends object = {}>(path: string, method: 'post', body: T): Promise<Response>;
  protected async fetchScoresApi<T extends object = {}>(
    path: string,
    method: HttpMethod = 'get',
    body?: T,
  ): Promise<Response> {
    try {
      const headers = new Headers({
        Accept: 'application/json',
        'Ocp-Apim-Subscription-Key': config.api_subscription_key,
      });
      const fetchBody = body ? JSON.stringify(body) : undefined;

      return await fetch(config.scores_api + path, { headers, mode: 'cors', method, body: fetchBody });
    } catch {
      throw new UnableToCompleteError('Fetch request failed', 404);
    }
  }

  protected async fetchFeedApi(path: string): Promise<Response> {
    try {
      const queryParams = { format: 'json', auth: config.feed_auth };
      const queryString = '?' + new URLSearchParams(Object.entries(queryParams));

      return await fetch(config.feed_api + path + queryString, { mode: 'cors' });
    } catch {
      throw new UnableToCompleteError('Fetch request failed', 404);
    }
  }

  protected async fetchDStvApi(path: string, queryParams: object): Promise<Response> {
    try {
      const queryString = Object.entries(queryParams).reduce((acc, cur) => `${acc};${cur.join('=')}`, '');

      return await fetch(config.dstv_api + path + queryString, { mode: 'cors' });
    } catch {
      throw new UnableToCompleteError('Fetch request failed', 404);
    }
  }
}
